
const styles = {
    container: {
        width: '100%',
        paddingTop: 10,
        paddingBottom: 10,
        paddingLeft: 15,
        paddingRight: 4,
        display: 'flex',
        alignItems: 'center',
        gap: 15,
        overflowX: 'auto',      // 👈 scroll horizontal
        overflowY: 'hidden',
        whiteSpace: 'nowrap',   // 👈 impede quebra de linha
    },
    button: {
        backgroundColor: 'transparent',
        border: 'none',
        borderBottom: '2px solid #D3873B',
        fontWeight: 'bold',
        whiteSpace: 'nowrap',   // 👈 texto do botão não quebra
        cursor: 'pointer',
        paddingBottom: 4,
    },
};

function SubGrupos({subgrupos, onSelect}){
    return (
        <div style={styles.container}>
            {/* preciso que este conteiner tenha overflow na horizontal caso a quantidade de subgrupos ultrapasse o 
            tamanho da tela */}
            {
                subgrupos.map((item, index)=>{
                    return (
                        <button 
                            key={index} 
                            type={'button'} 
                            style={styles.button} 
                            onClick={()=>onSelect(item.dsSubGrupo)}
                        >
                            {item.dsSubGrupo}
                        </button>
                    );
                })
            }
        </div>
    );
}

export default SubGrupos;